import {
  Component, OnInit, ViewChild, OnDestroy,
  ElementRef, AfterViewInit, ChangeDetectorRef, HostListener
} from "@angular/core";
import { ROUTES } from './vertical-menu-routes.config';
import { HROUTES } from '../horizontal-menu/navigation-routes.config';

import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { customAnimations } from "../animations/custom-animations";
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { LayoutService } from '../services/layout.service';
import {Settings_enum} from '../../conts/settings_enum';
import {ApiNameEnum} from '../../conts/apiname_enum';
import {map} from 'rxjs/operators';
import {RepositoryService} from '../../services/repository';

@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  animations: customAnimations
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[];
  level: number = 0;
  logoUrl = 'assets/img/logo.png';
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;
  menuShow = [];
  public menuROUTES: any[];
  public menuHROUTES: any[];
  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private repositoryService: RepositoryService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }



  ngOnInit() {
    const configMenu = localStorage.getItem('configMenu');
    if (!configMenu) {
      this.getSetingMenu();
    } else {
      this.menuShow = JSON.parse(configMenu);
      this.initFC();
    }


  }
  initFC() {
    const menuROUTES = JSON.stringify(ROUTES);
    const menuHROUTES = JSON.stringify(HROUTES);
    this.menuROUTES = this.converMenu(menuROUTES);
    this.menuHROUTES = this.converMenu(menuHROUTES);
    this.menuItems = this.menuROUTES;
  }
  async getSetingMenu() {
    const urlApi = Settings_enum.Menu + '/' +  ApiNameEnum.GetAll;
    this.repositoryService.getData(urlApi, {})
        .pipe(map((data) => data))
        .subscribe(
            (data) => {
              if (data != null) {
                localStorage.setItem('configMenu', data.mamenu);
                if (data.mamenu) {
                  this.menuShow = JSON.parse(data.mamenu);
                  this.initFC();
                }
              } else {
                this.menuShow = [];
                this.initFC();
              }
            },
            (error) => {
              console.log(error);
            }
        );
  }

  converMenu(menu) {
    let data = JSON.parse(menu);
    let me = this;
    data = data.filter( x => this.menuShow.includes(x.code) || x.alwaysShow);
    data.find( function (m) {
      m.submenu = m.submenu.filter( x => me.menuShow.includes(x.code) || x.alwaysShow);
    });
    return data;
  }

  ngAfterViewInit() {

    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
        }
      });

  }


  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
      if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout((() => {
        this.innerWidth = event.target.innerWidth;
          this.loadLayout();
      }).bind(this), 500);
  }

  loadLayout() {

    if (this.config.layout.menuPosition === "Top") { // Horizontal Menu
      if (this.innerWidth < 1200) { // Screen size < 1200
        this.menuItems = this.menuROUTES;
      }
    } else if (this.config.layout.menuPosition === "Side") { // Vertical Menu{
      this.menuItems = this.menuROUTES;
    }




    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/logo-dark.png';
    }
    else {
      this.logoUrl = 'assets/img/logo.png';
    }

    if(this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    }
    else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({ layout: conf.layout });

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {

    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    }
    else {
      this.perfectScrollbarEnable = true;
    }

  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

  }

}
